import * as React from 'react';
import { ActivityIndicator, View } from 'react-native';

import color from '../style/color';
import { redirectToAuth } from '../lib/auth/authRedirect';

/**
 * Full-document navigation into the migrated `/auth` zone so CloudFront's
 * reverse proxy serves the new app instead of the legacy SPA handling it
 * client-side. Renders a spinner while the browser tears down the current
 * document and fetches the migrated page. See CUX-698.
 */
function AuthRedirect() {
    React.useEffect(() => {
        redirectToAuth();
    }, []);
    return (
        <View style={{ height: '100vh', justifyContent: 'center' }}>
            <ActivityIndicator size="large" color={color.alto} />
        </View>
    );
}

export default AuthRedirect;
